var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsBroken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.875 1.75V12.25C0.875 12.4489 0.954018 12.6397 1.09467 12.7803C1.23532 12.921 1.42609 13 1.625 13H5.75L4.625 8.875L7.25 8.125L6.875 5.5L9.875 4L9.125 2.875L10.25 1H1.625C1.42609 1 1.23532 1.07902 1.09467 1.21967C0.954018 1.36032 0.875 1.55109 0.875 1.75ZM15.125 12.25V1.75C15.125 1.55109 15.046 1.36032 14.9053 1.21967C14.7647 1.07902 14.5739 1 14.375 1H13.25L11.75 3.25L12.875 5.125L9.5 6.625L9.875 9.625L7.25 10.375L8 13H14.375C14.5739 13 14.7647 12.921 14.9053 12.7803C15.046 12.6397 15.125 12.4489 15.125 12.25Z",
    stroke: "url(#paint0_linear_5131_13566)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4375 4.75C4.58668 4.75 4.72976 4.69074 4.83525 4.58525C4.94074 4.47976 5 4.33668 5 4.1875C5 4.03832 4.94074 3.89524 4.83525 3.78975C4.72976 3.68426 4.58668 3.625 4.4375 3.625C4.28832 3.625 4.14524 3.68426 4.03975 3.78975C3.93426 3.89524 3.875 4.03832 3.875 4.1875C3.875 4.33668 3.93426 4.47976 4.03975 4.58525C4.14524 4.69074 4.28832 4.75 4.4375 4.75Z",
    stroke: "url(#paint1_linear_5131_13566)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5131_13566",
    x1: 0.875,
    y1: 1,
    x2: 15.4129,
    y2: 1.35962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE594"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5131_13566",
    x1: 3.875,
    y1: 3.625,
    x2: 5.02294,
    y2: 3.64891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE594"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsBroken);
export default __webpack_public_path__ + "static/media/cs-broken.ccba5d4c7b95426a0db8707747f6c6b5.svg";
export { ForwardRef as ReactComponent };